<template>
  <div class="im-audio-message" :class="{ right: isMe }" @longpress="onlongpress">
    <div
      v-if="isMe"
      :style="{ width: `${130 + payloadAudio.second * 2}px` }"
      class="content right"
      @click="onSwitchPlay"
    >
      <div>{{ payloadAudio.second + 1 }}''</div>
      <div class="voice_icon voice_icon_right" :class="{ voice_icon_right_an: playing }" />
    </div>
    <div
      v-else
      :style="{ width: `${130 + payloadAudio.second * 2}px` }"
      class="content"
      @click="onSwitchPlay"
    >
      <div class="voice_icon voice_icon_left" :class="{ voice_icon_left_an: playing }" />
      <div>{{ payloadAudio.second + 1 }}''</div>
    </div>
  </div>
</template>

<script>
import { getElementBoundingClientReact } from '@/timpackage/utils/timInit'
export default {
  name: 'imAudioMessage',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {
            url: '',
            second: 0
          }
        }
      }
    }
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    payloadAudio() {
      return this.message.payload
    }
  },
  data() {
    return {
      playing: false,
      audioCom: {
        start: () => (this.playing = true),
        end: () => (this.playing = false)
      }
    }
  },
  methods: {
    async onlongpress() {
      const info = await getElementBoundingClientReact('.im-audio-message', this)
      this.$emit('menu', {
        info,
        message: this.message
      })
    },
    onSwitchPlay() {
      this.$emit('play', {
        message: this.message,
        cb: this.audioCom
      })
    },
    moveStart() {},
    moveOver: () => {}
  }
}
</script>

<style lang="scss" scoped>
.im-audio-message {
  display: flex;
  max-width: 8.533333rem;
  height: 1.664rem;

  .voice_icon {
    height: 0.725333rem;
    width: 0.725333rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .voice_icon_right {
    background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-left-3.png);
    margin-left: 0.213333rem;
  }

  .voice_icon_left {
    background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-right-3.png);
    margin-right: 0.213333rem;
  }

  .voice_icon_right_an {
    animation: voiceAn_right 1s linear alternate infinite;
  }

  .voice_icon_left_an {
    animation: voiceAn_left 1s linear alternate infinite;
  }

  .content {
    display: flex;
    align-items: center;
    padding-left: 0.426667rem;
    padding-right: 0.426667rem;
    height: 1.664rem;
    background: #d4ebff;
    border-radius: 0.170667rem;
    box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

    &.right {
      justify-content: flex-end;
    }
  }

  @keyframes voiceAn_right {
    0% {
      background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-left-1.png);
    }

    50% {
      background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-left-2.png);
    }

    100% {
      background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-left-3.png);
    }
  }

  @keyframes voiceAn_left {
    0% {
      background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-right-1.png);
    }

    50% {
      background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-right-2.png);
    }

    100% {
      background-image: url(https://pharmacyimg.docbook.com.cn/mini_doctor/pages/chat/voice-right-3.png);
    }
  }
}
</style>
